import * as types from './types'
import storage from '@/plugins/storage'
const cleanLocation = {
  firm: null,
  company: null,
  firstName: null,
  lastName: null,
  addressLines: null,
  city: null,
  stateProvince: null,
  postalCode: null,
  country: null,
  phoneNo: null,
  email: null,
  firmType: null,
  companyId: null,
  timezoneId: null,
  languageId: null,
  cccId: null,
  firmNumber: null,
  cccDiag: null,
  parentName: null
}
export default () => ({
  pageSize: storage.session.getItem(types.LOCATIONS_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.LOCATIONS_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.LOCATIONS_SORT_DIR) || 'asc',
  orderBy: storage.session.getItem(types.LOCATIONS_ORDER_BY) || 'firm',
  filterBy: parseInt(storage.local.getItem(types.LOCATIONS_FILTER_BY)) || null,
  filterOptions: [],
  defaultLocation: JSON.parse(JSON.stringify(cleanLocation)),
  locationTree: [],
  networkTree: [],
  locations: [],
  location: null,
  locationsFound: [],
  preferences: [],
  insuranceFound: [],
  insurance: [],
  providerFound: [],
  providers: [],
  addLocation: null,
  foundLocations: [],
  calibrationPricing: [],
  providerProfile: null,
  providerReviews: [],
  serviceMethodOptions: [],
  serviceListOptions: [],
  trainingCertificationOptions: []
})



// WEBPACK FOOTER //
// ./src/store/modules/locations/state.js